import axios from "axios";

const API_URL = `${process.env.REACT_APP_API_ENDPOINT}/api/users`;
const API_URL_LOGIN = `${process.env.REACT_APP_API_ENDPOINT}`;

class UserService {
    getAll() {
        return axios.get(`${API_URL}/all`, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')?.trim()}`
            }
        });
    }
    getAllActive() {
        return axios.get(`${API_URL}/all-active`, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')?.trim()}`
            }
        });
    }
    getFilterRole(roleFilter) {
        return axios.get(`${API_URL}/role-filter`, {
            params: {
                role: roleFilter            },
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')?.trim()}`
            }
        });
    }
    login(user) {
        return axios.post(`${API_URL_LOGIN}/auth/login`, user);
    }
    update(user) {
        return axios.put(`${API_URL}/update`, user, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')?.trim()}`
            }
        });
    }
    changePassword(data) {
        return axios.put(`${API_URL}/change-password`, data, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')?.trim()}`
            }
        });
    }
    upload(formData) {
        return axios.post(`${API_URL}/upload-avatar`, formData, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')?.trim()}`,
              'Content-Type': 'multipart/form-data'
            }
        });
    }
}

export default new UserService();